export const STALE_STATUSES = ['PENDING', 'CONFIRMED'];
export const STALE_THRESHOLD_MS = 10 * 60 * 1000;
export const STALE_REPEAT_MS = 5 * 60 * 1000;

export const parseOrderDate = (val) => {
  if (!val) return 0;
  if (typeof val === 'number') return val;
  return Date.parse(val) || 0;
};

export const getStaleReferenceTime = (order) => {
  if (!order) return 0;
  if (order.status === 'PENDING') {
    return parseOrderDate(order.createdAt || order.created_at);
  }
  return parseOrderDate(order.updatedAt || order.updated_at);
};

export const getOrderAgeMinutes = (order) => {
  const ref = getStaleReferenceTime(order);
  if (!ref) return 0;
  return Math.floor((Date.now() - ref) / 60000);
};

export const isOrderStale = (order) => {
  if (!order || !STALE_STATUSES.includes(order.status)) return false;
  const ref = getStaleReferenceTime(order);
  if (!ref) return false;
  return Date.now() - ref >= STALE_THRESHOLD_MS;
};

export const isMonitoredStatus = (status) => STALE_STATUSES.includes(status);

export const STATUS_LABELS = {
  PENDING: 'Pendente',
  CONFIRMED: 'Confirmado',
  PREPARING: 'Preparando',
  READY_FOR_DELIVERY: 'Pronto para entrega',
  OUT_FOR_DELIVERY: 'Saiu para entrega',
  DELIVERED: 'Entregue',
  CANCELLED: 'Cancelado',
};
